export default __webpack_public_path__ + "static/media/YAS0330.34I-29538_-17079_0.6fbb1047.jpg";